import { EditCoverUploadTabSelection } from "src/screens/(internal)/EditCoverGalleryModal/types";
import createFetchWithRetry from "src/shared/helpers/createFetchWithRetry";

const fetchWithRetry = createFetchWithRetry();

const writeCoverUploadData = async (selection: EditCoverUploadTabSelection, writeUrl: string) => {
	const { file, url } = selection;
	if (file) {
		const res = await fetchWithRetry(writeUrl, {
			method: "PUT",
			body: file,
			headers: {
				"Content-Type": file.type,
			},
		});
		if (!res.ok) {
			throw new Error("Error uploading photo data");
		}
	} else {
		const urlRes = await fetchWithRetry(url);
		if (!urlRes.ok) {
			throw new Error("Error uploading photo data");
		}
		const res = await fetchWithRetry(writeUrl, {
			method: "PUT",
			body: urlRes.body,
			headers: {
				"Content-Type": urlRes.headers.get("Content-Type") ?? "binary/octet-stream",
			},
		});
		if (!res.ok) {
			throw new Error("Error uploading photo data");
		}
	}
};
export default writeCoverUploadData;
